export class QueryService {
    public static buildQueryParameters(parameters: Array<[string, string]>): string {
        let queryString: string = "";
        if (parameters?.length > 0) {
            for (const param of parameters) {
                queryString += `${queryString.length > 0 ? "&" : "?"}${param[0]}=${param[1]}`;
            }
        } else {
            return "";
        }

        return queryString;
    }
}
